import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import Navbar from "../Navbar";
import { Form, Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { toastSuccess, toastError } from "../../utilis/toast";
import Api from "../../Api/Api";
import { FaUser, FaEnvelope, FaLock } from "react-icons/fa";
import axios from 'axios';

import 'react-toastify/dist/ReactToastify.css';
import { API } from "../../API";
import { useAppContext } from "../../Context/AppContext";

const LoginForm = () => {
  const { headerLogo } = useAppContext();

  const history = useHistory();

  // State management
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });

  // Handle input changes
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });

    // Simple validation
    const { name, value } = e.target;
    if (name === "email" && !/\S+@\S+\.\S+/.test(value)) {
      setErrors({ ...errors, email: "Invalid email format" });
    } else if (name === "password" && value.length < 8) {
      setErrors({ ...errors, password: "Password must be at least 8 characters" });
    } else {
      setErrors({ ...errors, [name]: "" });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Set up the request headers if necessary (like authorization token)
      const headers = {
        'Content-Type': 'application/json',
        // Add more headers here if required, e.g.:
        // 'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
      };

      // Make the API request using Axios
      const response = await axios.post(`${API}/api/client/signin`, data, { headers });

      // If the response is successful, save the token to localStorage
      if (response && response.data) {
        localStorage.setItem("auth", JSON.stringify({ token: response.data.token }));
        toastSuccess("Login Successful");

        history.push("/");
        window.location.reload(); // Optionally, remove this if not needed
      }
    } catch (err) {
      // Handle error cases, show error toast
      toastError(
        err?.response?.data?.message || "Something went wrong. Please try again."
      );
      console.error("Error during sign-in:", err);
    } finally {
      setLoading(false); // Reset loading state
    }
  };



  return (
    <>
      <Navbar />

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div
          className="bg-white rounded shadow p-4"
          style={{ width: "100%", maxWidth: "400px" }}
        >
          <div className="text-center mb-3">
            {headerLogo ? (
              <img src={headerLogo} alt="Logo" className="img-fluid" />
            ) : (
              <h1 className="text-primary fw-bold">SoComOTT</h1>
            )}
          </div>
          <h3 className="text-center mb-4">Sign In</h3>
          <p className="text-center mb-4 text-muted">
            Sign in to access your account
          </p>

          <Form onSubmit={handleSubmit}>
            {/* Email Field */}
            <Row className="mb-3">
              <label htmlFor="email" className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaEnvelope />
                </span>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="Enter Your Email"
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.email && (
                <div className="text-danger mt-1">{errors.email}</div>
              )}
            </Row>

            {/* Password Field */}
            <Row className="mb-3">
              <label htmlFor="password" className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaLock />
                </span>
                <input
                  id="password"
                  name="password"
                  type="password"
                  className={`form-control ${errors.password ? "is-invalid" : ""}`}
                  placeholder="Enter Your Password"
                  onChange={handleChange}
                  required
                  minLength={8}
                />
              </div>
              {errors.password && (
                <div className="text-danger mt-1">{errors.password}</div>
              )}
            </Row>

            {/* Submit Button */}
            <Row className="text-center mb-3 p-2">
              <button
                type="submit"
                className="btn btn-outline-primary w-100 "
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </Row>
          </Form>

          {/* Sign Up Link */}
          <div className="text-center text-muted mt-3">
            Need an Account? <Link to="/register">Sign Up</Link>
          </div>
        </div>

        <ToastContainer position="top-center" autoClose={2000} />      </div>
    </>
  );
};

export default LoginForm;
